//USERS TYPES
export const GET_LOGIN = "GET_LOGIN";
export const GET_AUTH_REFUSE = "GET_AUTH_REFUSE";
export const GET_LOGOUT = "GET_LOGOUT";
export const GET_AUTH = "GET_AUTH";

//PRODUCT TYPES

export const FETCH_PRODUCTS = "FETCH_PRODUCTS";
export const FETCH_LOADING = "FETCH_LOADING";
export const FETCH_ERROR = "FETCH_ERROR";
export const FETCH_ONE_PRODUCT = "FETCH_ONE_PRODUCT";
export const FETCH_SEARCH = "FETCH_SEACH";

//CART TYPES

export const FETCH_ADD_CART = "FETCH_ADD_CART";
export const FETCH_CART = "FETCH_CART";
export const FETCH_REMOVE_CART = "FETCH_REMOVE_CART";


//ORDER TYPES

export const FETCH_POST_ORDER = "FETCH_POST_ORDER";


//CATEGORIA TYPES

export const FETCH_CATEGORIA = "FETCH_CATEGORIA";